import $ from 'jquery'

function pad2(n) {
  if (n < 10) {
    return '0' + n
  }

  return n
}

function ymd(date) {
  const YYYY = date.getFullYear()
  const MM = pad2(date.getMonth() + 1)
  const DD = pad2(date.getDate())

  return `${YYYY}-${MM}-${DD}`
}

$('input[type="date"]').each(function () {
  let value
  if (!this.value) {
    value = ymd(new Date())
    this.value = value
    // N.B. also update default value
    this.defaultValue = value
  }
})
